import L from 'leaflet'

/**
 *
 * @param {{coordinates: number[]}} location
 * @param {number} distance
 * @param {number} bearing
 * @return {[*,*]}
 */
export function latLongFromBearingAndDistance(location, distance, bearing) {
  const RADIUS = 6371000 //earthRadius
  const RADPERDEGREE = Math.PI / 180.0

  const lat1 = RADPERDEGREE * location.coordinates[1]
  const lon1 = RADPERDEGREE * location.coordinates[0]
  const bearingWithRadius = RADPERDEGREE * bearing
  const lat2 = Math.asin(
    Math.sin(lat1) * Math.cos(distance / RADIUS) +
      Math.cos(lat1) * Math.sin(distance / RADIUS) * Math.cos(bearingWithRadius)
  )
  const lon2 =
    lon1 +
    Math.atan2(
      Math.sin(bearingWithRadius) * Math.sin(distance / RADIUS) * Math.cos(lat1),
      Math.cos(distance / RADIUS) - Math.sin(lat1) * Math.sin(lat2)
    )
  return [lat2 / RADPERDEGREE, lon2 / RADPERDEGREE]
}

/**
 * Get leaflet map bounds from locations array
 * @param locationsArray
 */
export function getBounds(locationsArray) {
  const pointsArray = locationsArray.map(location => {
    return L.point(location)
  })
  const leafletBounds = L.bounds(pointsArray)

  const bottomLeft = leafletBounds.getBottomLeft(),
    topRight = leafletBounds.getTopRight(),
    southWest = L.latLng(getLatLonFromPoint(bottomLeft)),
    northEast = L.latLng(getLatLonFromPoint(topRight)),
    mapBounds = L.latLngBounds(southWest, northEast)

  return mapBounds
}

/**
 * Get lat,lon array from L.point object
 * @param point
 * @returns {[*,*]}
 */
function getLatLonFromPoint(point) {
  return [point.x, point.y]
}
